export default __webpack_public_path__ + "static/media/helpButton.97d95099.svg";